import memoize from 'lodash/memoize';
import { getDomainGrantToken, supportsDomainGrant } from './domainGrant';
import { TokenProviderResult } from './types';

// todo: throw by default
let tokenProvider: () => Promise<TokenProviderResult> = async () => {
  throw new Error('failed to get access token');
};

if (supportsDomainGrant) {
  tokenProvider = getDomainGrantToken;
}

// domain grant doesn't currently work in slingshot so support it with implicit grant
// todo: implement implicit grant flow
// if (supportsImplicitGrant) {
//   tokenProvider = getImplicitGrantToken;
// }

let memoizedGetAccessToken = createGetAccessToken();

export const accessTokenManager = {
  get() {
    return memoizedGetAccessToken();
  },

  clear() {
    // clear state by creating new memoized function
    memoizedGetAccessToken = createGetAccessToken();
  },
};

function createGetAccessToken() {
  const cacheKey = 'token';

  const memoized = memoize(
    async () => {
      const [token, expiresIn] = await tokenProvider();
      const expiresInMs = expiresIn * 1000 * 0.9;

      // invalidate cache after expired
      setTimeout(() => {
        memoized.cache.delete(cacheKey);
      }, expiresInMs);

      return token;
    },
    () => cacheKey,
  );

  return memoized;
}
